import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  disabledCheckboxWhenEditAttendancesIsUnavailable: {
    id: 'rolesTableRowDetail.disabledCheckboxWhenEditAttendancesIsUnavailable.tooltip',
    defaultMessage: 'Aby włączyć tę opcję, wymagane jest również nadanie dostępu do edycji obecności dla tej Roli',
  },
});
